export const downloads = [
  {
    id: 'rules-2026',
    title: 'Club Rules & Bye-Laws 2026',
    type: 'PDF',
    size: '2.4 MB',
    category: 'Policies',
  },
  {
    id: 'membership-proposal',
    title: 'Membership Proposal Form',
    type: 'PDF',
    size: '1.1 MB',
    category: 'Forms',
  },
  {
    id: 'direct-debit',
    title: 'Direct Debit Mandate',
    type: 'PDF',
    size: '0.8 MB',
    category: 'Forms',
  },
  {
    id: 'event-booking',
    title: 'Private Event Booking Form',
    type: 'PDF',
    size: '1.5 MB',
    category: 'Forms',
  },
  {
    id: 'wine-list',
    title: 'Current Wine List - Autumn 2026',
    type: 'PDF',
    size: '3.2 MB',
    category: 'Dining',
  },
  {
    id: 'annual-report',
    title: 'Annual Report 2025-2026',
    type: 'PDF',
    size: '5.6 MB',
    category: 'Reports',
  },
]
